import clsx from "clsx";

export interface PlayerNameBadgeProps {
  name: string;
  guildName?: string | null;
  vipSubscriptionActive?: boolean;
  proActive?: boolean;
  className?: string;
  nameClassName?: string;
  size?: "sm" | "md";
}

/** Guild prefix, hero name, VIP diamond, Pro gold badge. */
export function PlayerNameBadges({
  name,
  guildName,
  vipSubscriptionActive,
  proActive,
  className,
  nameClassName,
  size = "md",
}: PlayerNameBadgeProps) {
  const textSize = size === "sm" ? "text-sm" : "text-base";
  const proSize = size === "sm" ? "text-[9px] px-1 py-0" : "text-[10px] px-1.5 py-0.5";

  return (
    <span
      className={clsx(
        "inline-flex flex-wrap items-center gap-1 min-w-0 max-w-full",
        className,
      )}
    >
      {guildName ? (
        <span className={clsx("text-violet-300/90 font-medium shrink-0", textSize)}>
          «{guildName}»
        </span>
      ) : null}
      <span className={clsx("font-semibold text-white truncate", textSize, nameClassName)}>
        {name}
      </span>
      {vipSubscriptionActive ? (
        <span className="shrink-0 text-sm leading-none" title="VIP">
          💎
        </span>
      ) : null}
      {proActive ? (
        <span
          className={clsx(
            "shrink-0 font-bold uppercase tracking-wide rounded border border-amber-400/80",
            "bg-amber-500/15 text-amber-200",
            proSize,
          )}
          title="Pro"
        >
          Pro
        </span>
      ) : null}
    </span>
  );
}
